import type { RouteRecordRaw } from 'vue-router'

import thesisManagerRoute, { thesisManagerRouteMap } from './thesis'
import userManagerRoute, { userManagerRouteMap } from './user'
import settingManagerRoute, { settingManagerRouteMap } from './setting'
import auth from './auth.ts'
import independent from './independent.ts'
import studentVersion3Route, { studentVersion3RouteMap } from './student/index'
import thesisV3ManagerRoute, { thesisV3ManagerRouteMap } from './thesisV3.ts'
import type { ModuleRoute } from '@/router/util'

export const ROOT_MODULE_MAP = Object.freeze({
  setting: 29000,
  thesis: 30000,
  user: 30100,
  student: 30200,
  teacher: 30300,
} as Record<string, number>)

export const MODULE_ROUTE_MAP = Object.freeze({
  ...thesisV3ManagerRouteMap,
  ...thesisManagerRouteMap,
  ...userManagerRouteMap,
  ...settingManagerRouteMap,
  ...studentVersion3RouteMap,
} as ModuleRoute)

export const STUDENT_VERSION_2_MODULE_NAME = 'studentThesisPlatform'
export const ROUTES: RouteRecordRaw[] = [
  {
    path: '/:symbol/platform',
    name: STUDENT_VERSION_2_MODULE_NAME,
    component: () => import('../../views/student/v2/ThesisPlatform.vue'),
    meta: {
      requiresAuth: true,
      roleStudent: true,
    },
  },
  {
    path: `/:symbol([A-Za-z]+)/manager/:module(${Object.keys(ROOT_MODULE_MAP).join('|')})`,
    name: 'moduleRootRoute',
    component: () => import('../../views/teacher/route.ts'),
    meta: {
      requiresAuth: true,
      roleManager: true,
    },
  },
  thesisManagerRoute,
  thesisV3ManagerRoute,
  userManagerRoute,
  settingManagerRoute,
  studentVersion3Route,
  ...auth,
  ...independent,
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('../../views/NotFound.vue'),
    meta: {
      requiresAuth: false,
    },
  },
]
